import Footer from "../Footer/Footer";
import Header from "../Header/Header";

export default function About() {
  return (
    <>
      <Header />
      <div id="page" className="full-page">
        <main id="content" className="site-main">
          {/* Inner Banner html start*/}
          <section className="inner-banner-wrap">
            <div
              className="inner-baner-container"
              style={{
                backgroundImage:
                  "url(https://res.cloudinary.com/dvop4v8kb/image/upload/c_fill,e_improve,w_1920,h_800/v1686402042/PakFlag_r1exbh.jpg)"
              }}
            >
              <div className="container">
                <div className="inner-banner-content">
                  <h1 className="inner-title">About us</h1>
                </div>
              </div>
            </div>
            <div className="inner-shape" />
          </section>
          {/* Inner Banner html end*/}
          {/* about section html start */}
          <section className="about-section about-page-section">
            <div className="about-service-wrap">
              <div className="container">
                <div className="section-heading">
                  <div className="row align-items-end">
                    <div className="col-lg-6">
                      <h5 className="dash-style">OUR TOUR GALLERY</h5>
                      <h2>
                        OUR AGENCY HAS BEEN PRESENT BEST IN THE MARKET
                      </h2>
                    </div>
                    <div className="col-lg-6">
                      <div className="section-disc">
                        <p>
                          Our agency has been proudly recognized as the best in
                          the market. With years of experience and a strong
                          commitment to excellence, we have established
                          ourselves as a trusted name in the travel industry.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="about-service-container">
                  <div className="row">
                    <div className="col-lg-4">
                      <div className="about-service">
                        <div className="about-service-icon">
                          <img
                            src="https://res.cloudinary.com/dvop4v8kb/image/upload/v1686477434/Price_tt4kh5.png"
                            alt=""
                          />
                        </div>
                        <div className="about-service-content">
                          <h4>AFFORDABLE PRICE</h4>
                          <p>
                            With our agency, you can enjoy incredible travel
                            experiences at affordable prices.
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-4">
                      <div className="about-service">
                        <div className="about-service-icon">
                          <img
                            src="https://res.cloudinary.com/dvop4v8kb/image/upload/v1686477530/SmallMap_kgpevx.png"
                            alt=""
                          />
                        </div>
                        <div className="about-service-content">
                          <h4>BEST DESTINATION</h4>
                          <p>
                            {" "}
                            Explore the hidden gems of Pakistan, a country
                            renowned for its breathtaking landscapes, rich
                            history, and warm hospitality.
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-4">
                      <div className="about-service">
                        <div className="about-service-icon">
                          <img
                            src="https://res.cloudinary.com/dvop4v8kb/image/upload/v1686477624/PersonalService_dhpl22.png"
                            alt=""
                          />
                        </div>
                        <div className="about-service-content">
                          <h4>PERSONAL SERVICE</h4>
                          <p>
                            {" "}
                            Our dedicated team is committed to providing
                            personalized assistance, ensuring that every aspect
                            of your travel experience is tailored to your
                            preferences and needs.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div
                  className="about-video-wrap"
                  style={{
                    backgroundImage:
                      "url(https://res.cloudinary.com/dvop4v8kb/image/upload/c_fill,e_improve,w_1200,h_700/v1687858647/Thumbnail_dtdekj.png)"
                  }}
                >
                  <div className="video-button">
                    <a
                      id="video-container"
                      href="https://www.youtube.com/embed/XZ1NcwErw2s"
                      data-video-id="IUN664s7N-c"
                    >
                      <i className="fas fa-play" />
                    </a>
                  </div>
                </div>
              </div>
            </div>
            {/* client section html start */}
            <div className="client-section">
              <div className="container">
                <div className="row">
                  <div className="col-lg-8 offset-lg-2">
                    <div className="section-heading text-center">
                      <h5 className="dash-style">OUR ASSOCAITES</h5>
                      <h2>PARTNER'S AND CLIENTS</h2>
                      <p>
                        We take pride in our strong partnerships with reputable
                        travel industry leaders, enabling us to offer exclusive
                        deals and access to premium services. Our valued
                        clients, who range from individual travelers to
                        corporate organizations, trust us to deliver exceptional
                        travel experiences tailored to their unique
                        requirements. Join our growing network of satisfied
                        partners and clients and let us exceed your
                        expectations.
                      </p>
                    </div>
                  </div>
                </div>
                <div className="client-wrap client-slider">
                  <div className="client-item">
                    <figure>
                      <img
                        src="https://res.cloudinary.com/dvop4v8kb/image/upload/v1686478290/Travel_lvck8y.png"
                        alt=""
                      />
                    </figure>
                  </div>
                  <div className="client-item">
                    <figure>
                      <img
                        src="https://res.cloudinary.com/dvop4v8kb/image/upload/v1686478358/Outdoor_ztcuzr.png"
                        alt=""
                      />
                    </figure>
                  </div>
                  <div className="client-item">
                    <figure>
                      <img
                        src="https://res.cloudinary.com/dvop4v8kb/image/upload/v1686478436/NatureMagazine_lr9cgj.png"
                        alt=""
                      />
                    </figure>
                  </div>
                  <div className="client-item">
                    <figure>
                      <img
                        src="https://res.cloudinary.com/dvop4v8kb/image/upload/v1686478554/Mountain_xuske6.png"
                        alt=""
                      />
                    </figure>
                  </div>
                  <div className="client-item">
                    <figure>
                      <img
                        src="https://res.cloudinary.com/dvop4v8kb/image/upload/v1686478633/Outdoor2_cveckg.png"
                        alt=""
                      />
                    </figure>
                  </div>
                </div>
              </div>
            </div>
            {/* client html end */}
            {/* callback section html start */}
            <div
              className="fullwidth-callback"
              style={{
                backgroundImage:
                  "url(https://res.cloudinary.com/dvop4v8kb/image/upload/c_fill,e_improve,w_1920,h_1000/v1687859089/sabeer-darr-smcJiDeZu34-unsplash_1_cxa2pd.jpg)"
              }}
            >
              <div className="container">
                <div className="section-heading section-heading-white text-center">
                  <div className="row">
                    <div className="col-lg-8 offset-lg-2">
                      <h5 className="dash-style">CALLBACK FOR MORE</h5>
                      <h2>GO TRAVEL.DISCOVER. REMEMBER US!!</h2>
                      <p>
                        Embark on unforgettable journeys, explore new horizons,
                        and create lasting memories with us. Let us be your
                        trusted companion in your travel adventures, ensuring
                        every moment is filled with joy, wonder, and the desire
                        to relive those cherished experiences.
                      </p>
                    </div>
                  </div>
                </div>
                <div className="callback-counter-wrap">
                  <div className="counter-item">
                    <div className="counter-item-inner">
                      <div className="counter-icon">
                        <img
                          src="https://res.cloudinary.com/dvop4v8kb/image/upload/v1686476968/Clients_o6ptym.png"
                          alt=""
                        />
                      </div>
                      <div className="counter-content">
                        <span className="counter-no">
                          <span className="counter">500</span>K+
                        </span>
                        <span className="counter-text">Satisfied Clients</span>
                      </div>
                    </div>
                  </div>
                  <div className="counter-item">
                    <div className="counter-item-inner">
                      <div className="counter-icon">
                        <img
                          src="https://res.cloudinary.com/dvop4v8kb/image/upload/v1686477064/Award_rjlu14.png"
                          alt=""
                        />
                      </div>
                      <div className="counter-content">
                        <span className="counter-no">
                          <span className="counter">250</span>K+
                        </span>
                        <span className="counter-text">Awards Achieve</span>
                      </div>
                    </div>
                  </div>
                  <div className="counter-item">
                    <div className="counter-item-inner">
                      <div className="counter-icon">
                        <img
                          src="https://res.cloudinary.com/dvop4v8kb/image/upload/v1686477118/ActiveUsers_egr7ec.png"
                          alt=""
                        />
                      </div>
                      <div className="counter-content">
                        <span className="counter-no">
                          <span className="counter">15</span>K+
                        </span>
                        <span className="counter-text">Active Members</span>
                      </div>
                    </div>
                  </div>
                  <div className="counter-item">
                    <div className="counter-item-inner">
                      <div className="counter-icon">
                        <img
                          src="https://res.cloudinary.com/dvop4v8kb/image/upload/v1686477158/AMap_z1ddea.png"
                          alt=""
                        />
                      </div>
                      <div className="counter-content">
                        <span className="counter-no">
                          <span className="counter">10</span>K+
                        </span>
                        <span className="counter-text">Tour Destnation</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* callback html end */}
          </section>
          {/* about html end */}
        </main>
        
      </div>
      <Footer />
    </>
  );
}
